module.exports = __webpack_public_path__ + "static/Inter-Regular-04a0cb7e189feb1b67df7abd64afe15b.woff";